import { Modal } from 'almanac-ui/Modal'
import { Button } from 'blaze-ui/Button'
import { Text } from 'blaze-ui/Text/Text'
import Styles from './NoAccountWarningModal.module.scss'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { integrationToName } from 'components/IntegrationRequiredModal/IntegrationRequiredModal'

interface Props {
  onConnect: () => void
  onScheduleDrafts: () => void
  onCancel: () => void
  platform: ExternalIntegrationEnum
}

export const NoAccountWarningModal = ({ onConnect, onCancel, onScheduleDrafts, platform }: Props) => {
  const platformName = integrationToName[platform]
  return (
    <Modal.Root onPressOutside={onCancel}>
      <Modal.Header title={'Connect your account'} />
      <Modal.Content>
        <Text>
          Your {platformName} account is not connected, so all posts will be scheduled as drafts and will not be
          auto-posted at their scheduled time.
        </Text>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Button size="lg" variant="tertiary" onPress={onCancel}>
            Cancel
          </Button>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <div className={Styles.buttonGroup}>
            <Button size="lg" onPress={onScheduleDrafts} variant="tertiary">
              Schedule as Drafts
            </Button>
            <Button size="lg" onPress={onConnect}>
              Connect Account
            </Button>
          </div>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
